import script from "./ClientProjects.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientProjects.vue?vue&type=script&setup=true&lang=ts"

import "./ClientProjects.vue?vue&type=style&index=0&id=efb9096a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efb9096a"]])

export default __exports__